(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('NotificationService', service);

    function service($timeout, lodash) {
        var time = new Date(),
            value = {},
            timeoutPromise = null;

        return {
            get: get,
            set: set,
            change: change
        };

        function get() {
            return value;
        }

        function set(val) {
            value = val;
            time = new Date();
            if (lodash.has(value, 'hide_after')) {
                if (timeoutPromise != null) {
                    $timeout.cancel(timeoutPromise);
                }
                timeoutPromise = $timeout(function() {
                    value = {};
                    time = new Date();
                }, value.hide_after);
            }
        }

        function change() {
            return time;
        }
    }
})();
